import { render } from "./DetailsOrder.vue?vue&type=template&id=434660e2&scoped=true"
import script from "./DetailsOrder.vue?vue&type=script&lang=js"
export * from "./DetailsOrder.vue?vue&type=script&lang=js"

import "./DetailsOrder.vue?vue&type=style&index=0&id=434660e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434660e2"]])

export default __exports__